import { safeRedirectPath } from "./safeRedirect";

// This marker is browser routing context, never authentication/authorization.
// Keep it in sync with the first AASA exclusion rule.
export const WEB_OAUTH_BROWSER_PARAM = "web_auth";

export function webOAuthCallbackUrl(origin: string, base: string, next?: string): URL {
  const callback = new URL(`${origin}${base}auth/callback`);
  callback.searchParams.set(WEB_OAUTH_BROWSER_PARAM, "1");
  const safeNext = safeRedirectPath(next);
  if (safeNext !== "/") callback.searchParams.set("next", safeNext);
  return callback;
}
